export const MIDDLEWARE_SLUG = "/edge/recruiter-outreach-email/campaing";
const OUTREACH = '/outreach-edge-api/api/v1'
const WHATS_APP = '/whatsapp-edge-api/api/v1'

export const endPoints = {
    FOLDER_LIST: `/recruiter-edge-actions/api/v1/folder`,
    PERSONAL_FOLDER: `/recruiter-edge-actions/api/v1/folder/personal`,
    LOCATION_LIST: `/edge/recruiter/v4/recruiter-srp/api/v1/master-data`,
    HEADER: `/recruiter4chat/common/get/header`,
    AUTHENTICATE_USER: '/cassowary/session/getuser',
    RESET_TRACKING: `${OUTREACH}/campaign/event/reset-tracking`,
    
    CAMPAIGN_REQUEST: `${OUTREACH}/campaign`,
    CAMPAIGN_TEMPLATES: `${OUTREACH}/campaign/templates`,
    CAMPAIGN_LIST: `${OUTREACH}/campaign/details/with-filter`,
    CAMPAIGN_STAGE: `${OUTREACH}/campaign/candidate/details`,
    AUTHENTICATE_EMAIL: `${OUTREACH}/mail/authenticate`,
    CONTACTED_EMAILS_COUNT: `${OUTREACH}/campaign/get/already/contacted/count`,
    CONTACTABLE_EMAILS_COUNT: `${OUTREACH}/campaign/get/contactable/count`,
    PAUSE_CAMPAIGN: `${OUTREACH}/campaign/pause`,
    RESUME_CAMPAIGN: `${OUTREACH}/campaign/resume`,
    ABORT_CAMPAIGN: `${OUTREACH}/campaign/finish`,
    COMPANY_DETAILS: `${OUTREACH}/campaign/company`,
    WITH_AI: `${OUTREACH}/content/personalisation/with/ai`,
    WITHOUT_AI: `${OUTREACH}/content/personalisation/without/ai`,
    JOB_DESCRIPTION_AI: `${OUTREACH}/content/personalisation/jd/with/ai`,
    COMPANY_MEDIA: `${OUTREACH}/branding/corp`,
    SIGNATURE : `${OUTREACH}/branding/recruiter/signature`,
    FAQS : `${OUTREACH}/campaign/FAQ`,
    SEEKERS_PENDING:`${OUTREACH}/campaign/count/pending/seeker/mail`,
    SEARCH_ATTRIBUTES: `${OUTREACH}/campaign/search/attributes`,
    DRAFT_DATA: `${OUTREACH}/campaign/draft`,
    JOB_LIST: `search-service/keyword/suggestion`,
    JOB_LIST_V2: `v2/suggest.html/master-data`,
    TOP_UP: "/edge-dashboard/api/v2/actions/outreach/topup",
    INVENTORY_USAGE:`/edge-hoatzin/inventory/outreach/usage`,
    CHECK_REVAMP_SERVICE: "/edge-dashboard/v2/dashboard/revamp/services",
    
    // event tracking
    EVENT_TRACKING: "/edge/recruiter/v4/recruiter-srp/api/v1/eventTracking",
    CAMPAIGN_STATUS_LIST: '/outreach-edge-api/api/v1/campaign/all/status',
    HEALTHTRACKER: "/recruiter-edge-event-tracking/api/v1/tracking/page/load/event",
    INVENTORY_PURCHASED: "/edge-hoatzin/inventory/edge/purchased/corporate",

    GET_DRAFT_DETAILS: `${WHATS_APP}/campaign/draft`,
    WHATS_APP_FAQ: `${WHATS_APP}/campaign/FAQ`,
    WHATS_APP_TEMPLATES: `${WHATS_APP}/campaign/templates`,
    WHATS_APP_TEMPLATES_PLACEHOLDERS: `${WHATS_APP}/campaign/placeholders`,
    START_CAMPAIGN: `${WHATS_APP}/campaign/request`,
    SENDER_DETAILS:`${WHATS_APP}/waba`,
    DOWNLOAD_WHATS_APP_REPLIES: `${WHATS_APP}/campaign/excel`,
    WHATS_APP_CAMPAIGN_STAGE: `${WHATS_APP}/campaign/candidate/details`,
    FETCH_REVAMP_SERVICES: "/edge-folder-management/api/v2/folder/revamp/services"
}

